document.addEventListener("DOMContentLoaded", function() {
    // document.querySelector('.my-cart__close').click(function(){
    //     document.querySelector('body').classList.remove('js-my-cart-open');
    // });
    // document.querySelector('.my-cart__add-order-note').click(function(){
    //     document.querySelector('.cart-note').classList.toggle('currently-hidden');
    // });
});

